import { render, staticRenderFns } from "./editGame.vue?vue&type=template&id=7d683e44"
import script from "./editGame.vue?vue&type=script&lang=js"
export * from "./editGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports